<div class="header flex flex-col">
  <div class="flex header-device">
    <h1 class="mr-2" *ngIf="device">
      {{
        device.shortDeviceName ||
          ('+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
            device.deviceType.toUpperCase() | translate) +
            ' ' +
            (memberId$ | async | value2: featurePropertyKey.value:'')
      }}
    </h1>
    <ng-container *ngIf="powerLimitationLabel$ | async as labelsWithTooltip">
      <div class="flex limitation-labels">
        <app-pill
          *ngFor="let item of labelsWithTooltip"
          class="flex flex-row justify-center items-center mr-2"
          [type]="pillType.primary"
          [matTooltip]="
            item.isConsumption
              | booleanSuffix
                : [
                    '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.TOOLTIP.GRID_CONSUMPTION_LIMIT',
                    '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.TOOLTIP.PV_FEED_IN_LIMIT'
                  ]
              | translate
                : {
                    value: item | featureLike | value2: featurePropertyKey.value,
                    unit: item | featureLike | unit: featurePropertyKey.value
                  }
          "
        >
          {{ item.label | translate }}
        </app-pill>
      </div>
    </ng-container>
  </div>
  <span>{{ device.boilerSerial }}</span>
  <span *ngIf="device && devicesStore.isFullCascadeMemberIds$ | async">
    {{
      isLeadCascadeV2Device
        ? ('+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.LEAD_DEVICE' | translate)
        : ('+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.LAG_DEVICE' | translate) +
          ' #' +
          device.memberId
    }}
  </span>
</div>

<app-feature-tiles-grid [id]="'installation-panels-' + cascadeIndex" cdkDropListGroup>
  <ng-container *ngFor="let panel of panels; trackBy: trackBy">
    <ng-container [ngSwitch]="panel.panel">
      <!-- Notification Tile -->
      <ng-container *ngSwitchCase="panelTypes.NotificationTile">
        <div
          *ngIf="device.status === DeviceStatusType.Offline"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.NotificationTile"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-notification-tile
          >
            <app-notification-tile data-at-tile="notification"> </app-notification-tile>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- DHW Panel -->
      <ng-container *ngSwitchCase="panelTypes.Dhw">
        <div
          *ngIf="dhw$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.Dhw"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-v2-device-dhw-panel-tile
          >
            <app-warm-water data-at-tile="dhw" [deviceId]="device.id"> </app-warm-water>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Buffer Tank Panel -->
      <ng-container *ngSwitchCase="panelTypes.BufferTank">
        <div
          *ngIf="bufferTank$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.BufferTank"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-buffer-tank-tile
          >
            <app-buffer-tank data-at-tile="buffer-tank" [deviceId]="device.id"></app-buffer-tank>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Gas Consumption -->
      <ng-container *ngSwitchCase="panelTypes.GasConsumption">
        <ng-container *ngIf="!(installationDetailsStore.isInstallationVitocrossalNAType$ | async)">
          <div
            *ngIf="gasConsumptionChartData$ | async as chartData"
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="device.gatewaySerial + '-' + device.id"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              [panel]="panelTypes.GasConsumption"
              data-at-v2-device-gas-consumption-tile
            >
              <app-generic-consumption-chart-panel
                data-at-tile="gas-consumption"
                [title]="'+INSTALLATIONS.INSTALLATION.GAS_CONSUMPTION'"
                [chartData]="chartData"
                [overlayType]="availableOverlays.GasConsumption"
                [deviceSelectId]="device.selectId"
              ></app-generic-consumption-chart-panel>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Power Production -->
      <ng-container *ngSwitchCase="panelTypes.PowerProduction">
        <div
          *ngIf="powerProductionChartData$ | async as chartData"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.PowerProduction"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-power-production-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="power-production"
              [title]="'+INSTALLATIONS.INSTALLATION.POWER_PRODUCTION'"
              [deviceSelectId]="device.selectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.PowerProduction"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Summary Gas Consumption -->
      <ng-container *ngSwitchCase="panelTypes.SummaryGasConsumption">
        <ng-container *ngIf="!(gasConsumptionHeating$ | async)">
          <ng-container
            *ngrxLet="gasConsumptionSummaryHeating$ | async | ready as gasConsumptionSummaryHeating"
          >
            <ng-container
              *ngrxLet="gasConsumptionSummaryDhw$ | async | ready as gasConsumptionSummaryDhw"
            >
              <div
                *ngIf="gasConsumptionSummaryHeating || gasConsumptionSummaryDhw"
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="device.gatewaySerial + '-' + device.id"
                  [panel]="panelTypes.SummaryGasConsumption"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-v2-device-summary-gas-consumption-tile
                >
                  <app-generic-consumption-panel
                    data-at-tile="gas-consumption-summary"
                    [title]="'+INSTALLATIONS.INSTALLATION.SUMMARY_GAS_CONSUMPTION'"
                    [gasConsumptionSummaryHeating]="gasConsumptionSummaryHeating"
                    [gasConsumptionSummaryDhw]="gasConsumptionSummaryDhw"
                    [overlayType]="availableOverlays.SummaryGasConsumption"
                  ></app-generic-consumption-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Summary Power Consumption -->
      <ng-container *ngSwitchCase="panelTypes.SummaryElectricityConsumption">
        <ng-container *ngIf="!(powerConsumptionHeating$ | async)">
          <ng-container
            *ngrxLet="
              powerConsumptionSummaryHeating$ | async | ready as powerConsumptionSummaryHeating
            "
          >
            <ng-container
              *ngrxLet="powerConsumptionSummaryDhw$ | async | ready as powerConsumptionSummaryDhw"
            >
              <div
                *ngIf="powerConsumptionSummaryHeating || powerConsumptionSummaryDhw"
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="device.gatewaySerial + '-' + device.id"
                  [panel]="panelTypes.SummaryElectricityConsumption"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-v2-device-summary-electricity-consumption-tile
                >
                  <app-generic-consumption-panel
                    data-at-tile="electricity-consumption-summary"
                    [title]="'+INSTALLATIONS.INSTALLATION.SUMMARY_ELECTRICITY_CONSUMPTION'"
                    [powerConsumptionSummaryHeating]="powerConsumptionSummaryHeating"
                    [powerConsumptionSummaryDhw]="powerConsumptionSummaryHeating"
                    [overlayType]="availableOverlays.SummaryElectricityConsumption"
                  ></app-generic-consumption-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Summary Autarky -->
      <ng-container *ngSwitchCase="panelTypes.Autarky">
        <div
          *ngIf="autarkySummary$ | async | ready as autarkySummary"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.Autarky"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-autarky-tile
          >
            <app-generic-consumption-panel
              data-at-tile="summary-autarky"
              [title]="'+INSTALLATIONS.INSTALLATION.AUTARKY'"
              [deviceSelectId]="device.id"
              [autarkySummary]="autarkySummary"
              [overlayType]="availableOverlays.Autarky"
            ></app-generic-consumption-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Heat Production -->
      <ng-container *ngSwitchCase="panelTypes.HeatProduction">
        <div
          *ngIf="heatProductionChartData$ | async as chartData"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.HeatProduction"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-heat-production-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="heat-production"
              [title]="'+INSTALLATIONS.INSTALLATION.HEAT_PRODUCTION'"
              [deviceSelectId]="device.selectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.HeatProduction"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Solar Power Production -->
      <ng-container *ngSwitchCase="panelTypes.SolarPowerProduction">
        <div
          *ngIf="solarPowerProductionChartData$ | async as chartData"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [panel]="panelTypes.SolarPowerProduction"
            [orderKey]="device.gatewaySerial + '-' + device.id"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-solar-power-production-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="solar-power-production"
              [title]="'+INSTALLATIONS.INSTALLATION.SOLAR_POWER_PRODUCTION'"
              [deviceSelectId]="device.selectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.SolarPowerProduction"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Electricity Consumption -->
      <ng-container *ngSwitchCase="panelTypes.ElectricConsumption">
        <div
          *ngIf="
            device.deviceType === heatingDeviceType &&
            !(devicesStore.isEcotronicDevice$ | async) &&
            (electricityConsumptionChartData$ | async) as chartData
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.ElectricConsumption"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-electric-consumption-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="electric-consumption"
              [title]="'+INSTALLATIONS.INSTALLATION.POWER_CONSUMPTION'"
              [chartData]="chartData"
              [overlayType]="availableOverlays.ElectricityConsumption"
              [deviceSelectId]="device.selectId"
            >
            </app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Fuel Consumption -->
      <ng-container *ngSwitchCase="panelTypes.FuelConsumption">
        <div
          *ngIf="
            device.deviceType === heatingDeviceType &&
            (devicesStore.isEcotronicDevice$ | async) &&
            (electricityConsumptionChartData$ | async) as chartData
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.FuelConsumption"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-fuel-consumption-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="fuel-consumption"
              [title]="'+INSTALLATIONS.INSTALLATION.FUEL_CONSUMPTION'"
              [chartData]="chartData"
              [overlayType]="availableOverlays.FuelConsumption"
              [deviceSelectId]="device.selectId"
            >
            </app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Energy Cockpit -->
      <ng-container *ngSwitchCase="panelTypes.EnergyCockpit">
        <div
          *ngIf="powerCumulativeProducedFeature$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.EnergyCockpit"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-v2-device-energy-cockpit-tile
          >
            <app-energy-cockpit-panel
              data-at-tile="energy-cockpit"
              [deviceSelectId]="device.selectId"
              [deviceId]="device.id"
            ></app-energy-cockpit-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Solar Panel -->
      <ng-container *ngSwitchCase="panelTypes.Solar">
        <div
          *ngIf="solar$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.Solar"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-v2-device-solar-tile
          >
            <app-solar
              data-at-tile="solar"
              [deviceSelectId]="device.selectId"
              [deviceId]="device.id"
            ></app-solar>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Fuel Cell Panel -->
      <ng-container *ngSwitchCase="panelTypes.FuelCell">
        <div
          *ngIf="(isFuelCellDevice$ | async) && device.status === DeviceStatusType.Online"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.FuelCell"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-fuel-cell-tile
          >
            <app-fuel-cell
              data-at-tile="fuel-cell"
              [deviceSelectId]="device.selectId"
              [deviceId]="device.id"
            ></app-fuel-cell>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Heating Zone/Circuits -->
      <ng-container *ngIf="availableCircuitsDetails$ | async as availableCircuits">
        <ng-container *ngFor="let circuit of availableCircuits">
          <ng-container
            *ngIf="
              circuit.feature.properties.type.value === circuitType.HeatingCircuit;
              then heatingCircuit;
              else TTCircuit
            "
          ></ng-container>

          <ng-template #TTCircuit>
            <ng-container *ngIf="panel.panel === getTTCircuitPanelName(circuit.circuitId)">
              <div
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="device.gatewaySerial + '-' + device.id"
                  [panel]="getTTCircuitPanelName(circuit.circuitId)"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-v2-device-circuit-heating-zone-tile
                >
                  <app-circuit-heating-zone-features-panel
                    data-at-tile="circuit-heating-zone"
                    [circuitId]="circuit.circuitId"
                    [deviceSelectId]="device.selectId"
                    [deviceId]="device.id"
                    [header]="installationService.getCircuitName(circuit.circuitId) | async"
                  >
                  </app-circuit-heating-zone-features-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-template>

          <ng-template #heatingCircuit>
            <ng-container *ngIf="panel.panel === getHeatingCircuitPanelName(circuit.circuitId)">
              <div
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="device.gatewaySerial + '-' + device.id"
                  [panel]="getHeatingCircuitPanelName(circuit.circuitId)"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-v2-device-heating-circuit-tile
                >
                  <app-heating-circuit-features-panel
                    data-at-tile="heating-circuit"
                    [circuitId]="circuit.circuitId"
                    [deviceSelectId]="device.selectId"
                    [deviceId]="device.id"
                    [header]="installationService.getCircuitName(circuit.circuitId) | async"
                    [attr.data-at-tile]="'heatingCircuit' + circuit.circuitId"
                  ></app-heating-circuit-features-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="devicesStore.isHeatingZoneAvailable$ | async">
        <ng-container
          *ngIf="
            devicesStore.getCallForHeatHeatingZoneIndex(device.selectId)
              | async as callForHeatHeatingZoneIndex
          "
        >
          <ng-container *ngIf="panel.panel === getCallForHeatHeatingZonePanelName()">
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="panel.panel"
              (cdkDropListDropped)="drop($event)"
            >
              <app-installation-ordered-element
                [orderKey]="device.gatewaySerial + '-' + device.id"
                [panel]="getCallForHeatHeatingZonePanelName()"
                cdkDrag
                [cdkDragDisabled]="isDragDropDisabled"
                data-at-v2-device-call-for-heat-heating-zone-tile
              >
                <app-call-for-heat-heating-zone-features-panel
                  data-at-tile="call-for-heat-heating-zone"
                  [deviceSelectId]="device.selectId"
                  [deviceId]="device.id"
                  [header]="
                    installationService.getCallForHeatHeatingZoneName(
                      callForHeatHeatingZoneIndex.index
                    )
                  "
                >
                </app-call-for-heat-heating-zone-features-panel>
              </app-installation-ordered-element>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Ventilation -->
      <ng-container *ngSwitchCase="panelTypes.Ventilation">
        <ng-container *ngIf="ventilationMode$ | async | ready as mode">
          <ng-container *ngIf="ventilationProgram$ | async | ready as program">
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="panel.panel"
              (cdkDropListDropped)="drop($event)"
            >
              <app-installation-ordered-element
                [orderKey]="device.gatewaySerial + '-' + device.id"
                [panel]="panelTypes.Ventilation"
                cdkDrag
                [cdkDragDisabled]="isDragDropDisabled"
                [attr.data-feature]="program.feature + ' || ' + mode.feature"
                data-at-v2-device-ventilation-tile
              >
                <app-ventilation
                  data-at-tile="ventilation"
                  [deviceSelectId]="device.selectId"
                  [deviceId]="device.id"
                ></app-ventilation>
              </app-installation-ordered-element>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- ESS System -->
      <ng-container *ngSwitchCase="panelTypes.Battery">
        <div
          *ngIf="
            (isESSDevice$ | async) &&
            device.status === DeviceStatusType.Online &&
            (isEssBatteryOrHybrid$ | async)
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.Battery"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-device-battery-tile
          >
            <app-battery
              data-at-tile="device-battery"
              [deviceSelectId]="device.selectId"
              [deviceId]="device.id"
            ></app-battery>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Photovoltaics -->
      <ng-container *ngSwitchCase="panelTypes.Photovoltaics">
        <div
          *ngIf="photovoltaicCumulatedEnergy$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.Photovoltaics"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-v2-device-photovoltaics-tile
          >
            <app-photovoltaics
              data-at-tile="photovoltaics"
              [deviceSelectId]="device.selectId"
              [deviceId]="device.id"
            ></app-photovoltaics>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Electric heater -->
      <ng-container *ngSwitchCase="panelTypes.ElectricHeater">
        <ng-container *ngIf="electricHeater$ | async | ready as feature">
          <div
            *ngIf="feature?.properties?.enabled?.value?.length > 0"
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="device.gatewaySerial + '-' + device.id"
              [panel]="panelTypes.ElectricHeater"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              [attr.data-feature]="feature.feature"
              data-at-v2-device-electric-heater-tile
            >
              <app-electric-heater
                data-at-tile="electric-heater"
                [device]="device"
                [heatingRodIndex]="
                  device
                    | electricHeaterSelectHeatingRodIndex
                      : (electricHeaterService.aggregatedHeatingRodsIndexesWithBoilerSerials()
                          | async)
                "
              ></app-electric-heater>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Refrigerant Circuit -->
      <ng-container
        *ngIf="enabledRefrigerantCircuits$ | async | ready | featureValue: 'enabled' as circuitIds"
      >
        <ng-container *ngFor="let refrigerantCircuitId of circuitIds">
          <div
            *ngIf="panel.panel === panelTypes['RefrigerantCircuit' + refrigerantCircuitId]"
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="device.gatewaySerial + '-' + device.id"
              [panel]="panelTypes['RefrigerantCircuit' + refrigerantCircuitId]"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-v2-device-refrigerant-circuit-tile
            >
              <app-refrigerant-circuit-features-panel
                [attr.data-at-tile]="'refrigerantCircuit'"
                [refrigerantCircuitId]="refrigerantCircuitId"
                [header]="installationService.getRefrigerantCircuitName(refrigerantCircuitId)"
                [deviceSelectId]="device.selectId"
                [deviceId]="device.id"
              ></app-refrigerant-circuit-features-panel>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- ViCare thermostat -->
      <ng-container *ngSwitchCase="panelTypes.ViCareThermostat">
        <ng-container *ngIf="isVicareThermostatMode$ | async">
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="device.gatewaySerial + '-' + device.id"
              [panel]="panelTypes.ViCareThermostat"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-v2-device-vicare-thermostat-tile
            >
              <app-vicare-thermostat data-at-tile="vicare-thermostat"></app-vicare-thermostat>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Eco water -->
      <ng-container *ngSwitchCase="panelTypes.EcoWater">
        <div
          *ngIf="saltLevelDays$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial + '-' + device.id"
            [panel]="panelTypes.EcoWater"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-v2-device-eco-water-tile
          >
            <app-eco-water-features-panel data-at-tile="eco-water"></app-eco-water-features-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!--Internal Hydraulic-->
      <ng-container *ngSwitchCase="panelTypes.InternalHydraulic">
        <div
          *ngIf="
            (devicesStore.isE3HeatpumpDevice(device) | async) ||
            (devicesStore.isSCUDevice(device) | async)
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial"
            [panel]="panelTypes.InternalHydraulic"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-internalHydraulic-tile
          >
            <app-internal-hydraulic-features-panel
              data-at-tile="internalHydraulic"
              [deviceId]="device.id"
            ></app-internal-hydraulic-features-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Hybrid Pro Control Panel -->
      <ng-container *ngSwitchCase="panelTypes.HybridProControl">
        <div
          *ngIf="installationFeaturesStore.iselectIsHybridProTileVisible(device.id) | async"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="device.gatewaySerial"
            [panel]="panelTypes.HybridProControl"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-hybrid-pro-control-tile
          >
            <app-hybrid-pro-panel
              data-at-tile="hybridProControl"
              [deviceId]="device.id"
            ></app-hybrid-pro-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</app-feature-tiles-grid>
